const OverTimeDelComponent = () => import('@/views/hrm/OverTimeDel/OverTimeDelView')

export default [
    {
        path:'/OverTimeDelIndex',
        name:'OverTimeDelComponent',
        component:OverTimeDelComponent
    }
]